<template>
  <div>
    <div
      ref="bottomBar"
      class="scroll-fix-button-bar"
      :class="{ fullWidth: fullWidth, stepBtn: stepBtn, 'auto-height': autoHeight }"
      :style="{ position }"
    >
      <slot />
      <slot name="bottomBtn" />
    </div>
    <div
      v-if="!fixedBottomBarShow && _isSpaceForDisplay"
      class="scroll-fix-button-bar fixed"
      style="position: fixed"
      :style="{
        width: bottomBarWidth + 'px',
        left: bottomBarLeftPosition + 'px',
        height: bottomBarHeight + 'px',
      }"
      :class="{ fixFullWidth: fullWidth, stepBtn: stepBtn }"
    >
      <div v-if="hasMoreContent">
        <i v-for="i in 3" :key="i" class="icon-chevron-down bounce icon" />
      </div>
      <slot />
      <slot name="bottomBtn" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'ScrollFixedBottomBar',
  props: {
    bottomBarWidth: {
      type: Number,
      default: 0,
    },
    bottomBarLeftPosition: {
      type: Number,
      default: 0,
    },
    scroll: {
      type: Number,
      default: 0,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    stepBtn: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
    },
    autoHeight: {
      type: Boolean,
      default: false,
    },
    hasMoreContent: {
      type: Boolean,
      default: false,
    },
    visibleSpaceBelowParent: {
      type: Number,
    },
  },
  data: () => ({
    bottomBarHeight: 0,
    bottomBarTop: 0,
    fixedBottomBarShow: true,
    window: {
      width: 0,
      height: 0,
    },
  }),
  computed: {
    _isSpaceForDisplay() {
      if (!this.visibleSpaceBelowParent) return true;
      return this.visibleSpaceBelowParent - this.bottomBarHeight > 30;
    },
  },
  watch: {
    scroll() {
      this.$_getBottomBarHeight();
      this.$_bottomBarHide();
    },
    bottomBarHeight() {
      this.$emit('height-changed', this.bottomBarHeight);
    },
  },
  created() {
    window.addEventListener('resize', this.$_handleResize);
    window.addEventListener('resize', this.$_getBottomBarHeight);
    window.addEventListener('resize', this.$_bottomBarHide);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_handleResize);
    window.removeEventListener('resize', this.$_getBottomBarHeight);
    window.removeEventListener('resize', this.$_bottomBarHide);
  },
  mounted() {
    this.$_getBottomBarHeight();
    this.$_bottomBarHide();
  },
  methods: {
    $_handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    $_getBottomBarHeight() {
      if (!this.$refs.bottomBar) {
        return null;
      }
      let botttomHeight = this.$refs.bottomBar.getBoundingClientRect();
      this.bottomBarHeight = botttomHeight.height;
      this.bottomBarTop = botttomHeight.y;
    },
    $_bottomBarHide() {
      if (this.bottomBarWidth === 0 && this.bottomBarLeftPosition === 0) {
        this.fixedBottomBarShow = true;
        return;
      }
      this.window.height = window.innerHeight;
      if (this.window.height - this.bottomBarTop >= this.bottomBarHeight - 30) {
        this.fixedBottomBarShow = true;
      }
      if (this.window.height - this.bottomBarTop < this.bottomBarHeight - 30) {
        this.fixedBottomBarShow = false;
      }
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/scroll-fix-button-bar';
</style>
